export function NAV(props: { value: string | number; className?: string }) {
  return (
    <span className={props.className}>{Number(props.value).toFixed(2)}</span>
  );
}
